// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jm-0";
export var assigneeDetails = "_jm-1";
export var assigneeInfo = "_jm-2";
export var dropdownContainer = "_jm-4";
export var dropdownImage = "_jm-5";
export var editAssigneeInfo = "_jm-3";
export var editAssigneeModalContainer = "_jm-6";
export var hidden = "_jm-8";
export var input = "_jm-7";